import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import List from "../Components/Quotation/List";
import Add from "../Components/Quotation/Add";
import View from "../Components/Quotation/View";
import { useLocation } from "react-router-dom";
import View1 from "../Components/Quotation/View1";

function Quotation() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Quotation</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "view" ? ( // Check if comp is "scan"
            <View1 comp={comp} rowData={rowData} onChange={handleChange} />
          ) : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default Quotation;
